import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, useTheme } from '@mui/material';
import { ArrowUpIcon } from '@icons/ArrowUpIcon';
import { ArrowDownIcon } from '@icons/ArrowDownIcon';

import { FC, RefObject, useContext, useRef, useState } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { refineFonts } from '@/Theming/refineFonts';
import { useAnalytics } from '@hooks/useAnalytics';
import { REFINE_ANALYTICS_EVENTS } from '@/types/RefineAnalyticsEvents';

interface Props {
	scrollToTarget: (scrollTargetRef: RefObject<HTMLDivElement | null>) => void;
}

export const OUCFDeadlineDropdown: FC<Props> = ({ scrollToTarget }) => {
	const [accordionOpened, setAccordionOpened] = useState<boolean>(false);
	const { HowMuchTimeDoIHave } = useContext(LocalizationContext);
	const scrollTargetRef = useRef<HTMLDivElement>(null);
	const { trackRefineEvent } = useAnalytics();
	const theme: any = useTheme();
	const handleOpenAccordion = () => {
		setAccordionOpened((prevState) => !prevState);
		scrollToTarget(scrollTargetRef);
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.OUCF_CUSTOMER_OPENS_DEADLINE_TEXT);
	};

	return (
		<Accordion
			sx={{
				overflow: 'visible',
				'&:before': {
					display: 'none', // This removes the pseudo-element that might appear as a divider
				},
			}}
			disableGutters
			elevation={0}
			onClick={handleOpenAccordion}>
			<AccordionSummary
				sx={{
					display: 'flex',
					alignItems: 'center',
					width: 'fit-content',
					border: 'none',
					paddingInline: '0',
					paddingTop: '24px',
					'& .MuiAccordionSummary-expandIconWrapper': {
						transition: 'none',
						'&.Mui-expanded': {
							transform: 'none',
						},
					},
				}}
				expandIcon={
					accordionOpened ? (
						<ArrowUpIcon primaryColor={theme.palette.primary.main} />
					) : (
						<ArrowDownIcon primaryColor={theme.palette.primary.main} />
					)
				}>
				<Typography sx={{ ...refineFonts.mediumRegular }}>{HowMuchTimeDoIHave.ButtonText}</Typography>
			</AccordionSummary>
			<AccordionDetails sx={{ padding: '0' }}>
				<Typography
					dangerouslySetInnerHTML={{ __html: HowMuchTimeDoIHave.MainText }}
					sx={{ ...refineFonts.mediumRegular }}
				/>{' '}
				<Box sx={{ paddingTop: '20px' }} ref={scrollTargetRef} />
			</AccordionDetails>
		</Accordion>
	);
};
